/**
 * warehouseColumnManifest.js
 * ──────────────────────────
 * Authoritative column manifest for the Stored Items (warehouse occupancy) grid.
 * Keys map to fields returned by get_warehouse_items list mode — plus one derived
 * key, `location`, which the page augments onto each row from building/section/
 * row/stack (so sortRecords can sort on it). NO Owner column (Phase 3a scope).
 *
 * type: 'text' | 'number' | 'date' | 'boolean'   (drives sort + cell formatting)
 * readOnly: always true here — 3a is a read scaffold; writes land in 3b.
 */

export const WAREHOUSE_COLUMNS = [
  { key: 'warehouse_item_id',    label: 'Item ID',      type: 'text',    readOnly: true },
  { key: 'asset_type',           label: 'Asset Type',   type: 'text',    readOnly: true },
  { key: 'tracking_mode',        label: 'Tracking',     type: 'text',    readOnly: true },
  { key: 'quantity',             label: 'Qty',          type: 'number',  readOnly: true },
  { key: 'contract_id',          label: 'Contract',     type: 'text',    readOnly: true },
  { key: 'location',             label: 'Location',     type: 'text',    readOnly: true },
  { key: 'warehouse_status',     label: 'Status',       type: 'text',    readOnly: true },
  { key: 'current_received_date', label: 'Received',    type: 'date',    readOnly: true },
  { key: 'dwell_days',           label: 'Dwell (days)', type: 'number',  readOnly: true },
  { key: 'dwell_progress',       label: 'Dwell progress', type: 'text',  readOnly: true },
  { key: 'review',               label: 'Review',       type: 'text',    readOnly: true },
  { key: 'verified',             label: 'Verified',     type: 'boolean', readOnly: true },
  { key: 'hold',                 label: 'Hold',         type: 'boolean', readOnly: true },
];
